/* ========================================================================
   Videos
 ========================================================================== */

(function () {
  'use strict';

  const youTubeRegex =
    /https?:\/\/.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/|watch\/|live\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?\/]*).*/i;
  const vimeoRegex =
    /https?:\/\/(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/?)/i;

  function init() {
    const videos = document.querySelectorAll('[data-video]');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      initVideo(video);
    });

    document.addEventListener('cookieconsent_update', (event) => {
      if (typeof event.detail.grantedCategories !== 'object') return;

      if (event.detail.grantedCategories.indexOf('marketing') > -1) {
        removeConsentWarning();
      }
    });
  }

  function getVideoEmbedElementFromUrl(url, title) {
    title = title || '';

    const youTubeMatch = youTubeRegex.exec(url);
    const vimeoMatch = vimeoRegex.exec(url);

    // YouTube
    if (youTubeMatch && youTubeMatch.length >= 2) {
      var url = 'https://www.youtube-nocookie.com/embed/' + youTubeMatch[1] + '?rel=0&autoplay=1&showinfo=0&vq=hd1080';
      return createIframeElement(url, title, 'strict-origin-when-cross-origin');
    }

    // Vimeo
    if (vimeoMatch && vimeoMatch.length >= 2) {
      var url = 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1&dnt=1&quality=1080p';
      return createIframeElement(url, title);
    }

    return null;
  }

  function createIframeElement(src, title, referrerpolicy) {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('width', '1280');
    iframe.setAttribute('height', '720');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', title);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('tabindex', '0');
    iframe.setAttribute('allow', 'autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');

    if (referrerpolicy) {
      iframe.setAttribute('referrerpolicy', referrerpolicy);
    }

    return iframe;
  }

  function initVideo(video) {
    const preview = video.querySelector('[data-video-preview]');
    const button = video.querySelector('[data-video-button]');
    const iframe = video.querySelector('[data-video-iframe]');
    const videoUrl = button.getAttribute('data-video-url');

    button.addEventListener('click', (event) => {
      event.preventDefault();

      const iframeEl = getVideoEmbedElementFromUrl(videoUrl, button.getAttribute('aria-label'));
      if (iframeEl) iframe.appendChild(iframeEl);

      video.dataset.video = 'loaded';
      iframe.classList.remove('hidden');
      if (preview) preview.remove();
      button.remove();

      // Set focus to iframe for accessibility
      iframe.setAttribute('tabindex', '0');
      iframe.focus();

      // DATALAYER
      app.dataLayer.pushEvent('videoStart', {
        pageUrl: window.location.pathname,
        option: button.dataset.videoTitle || videoUrl,
      });

      // Reset iframe src, because Cookiebot blocks it
      // setTimeout(() => {
      //   const iframe = iframeWrapper.querySelector('iframe');
      //   if (!iframe.getAttribute('src')) {
      //     const src = iframe.getAttribute('data-cookieblock-src');
      //     iframe.setAttribute('src', src);
      //   }
      // }, 100);
    });
  }

  function removeConsentWarning() {
    const videos = document.querySelectorAll('[data-video]');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      const button = video.querySelector('[data-video-button]');
      const consent = video.querySelector('[data-video-consent]');

      button.classList.remove('hidden');
      if (consent) consent.remove();
    });
  }

  // function hasMarketingConsent() {
  //   return typeof Cookiebot !== 'undefined' ? Cookiebot.consent.marketing : false;
  // }

  init();
})();
